import Keycloak from 'keycloak-js'

const keycloakInstance = new Keycloak({
   url: "https://auth.bluesystem.it/keycloak",
  realm: "Bluesystem",
  clientId: "timereport",
});

export default keycloakInstance;